import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './_components/header/header.component';
import { HomeComponent } from './pages/home/home.component';
import { FooterComponent } from './_components/footer/footer.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { AllCurrenciesComponent } from './_components/all-currencies/all-currencies.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { DonateComponent } from './_components/donate/donate.component';
import { ClipboardModule } from 'ngx-clipboard';

registerLocaleData(localeFr, 'fr');
@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        HomeComponent,
        FooterComponent,
        AllCurrenciesComponent,
        DonateComponent
    ],
    imports: [
        BrowserModule,
        FontAwesomeModule,
        BrowserAnimationsModule,
        NgxPaginationModule,
        ClipboardModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        AppRoutingModule
    ],
    providers: [{ 
        provide: LOCALE_ID, useValue: 'fr-FR',
    }],
    bootstrap: [AppComponent]
})
export class AppModule { }
